(function () {
    'use strict';

    angular
        .module('papp')
        .controller('CustomerController', CustomerController);

    CustomerController.$inject = ['Customer', '$state', '$stateParams'];

    function CustomerController(Customer, $state, $stateParams) {
        var vm = this;
        var page = 1;
        var plateNumber = null;
        var email = null;
        var dateStart = null;

        vm.numberOfPages = 1;
        
        vm.customers = [];
       
        vm.plateNumberInput = null;
        vm.emailInput = null;
        
        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.firstPage = firstPage;
        vm.lastPage = lastPage;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.showCustomer = showCustomer;

        function prevPage() {
            toState(page - 1);
        }

        function nextPage() {
            toState(page + 1);
        }

        function firstPage() {
            toState(0);
        }

        function lastPage() {
            toState(vm.numberOfPages);
        }

        function toState(toPage){
            $state.go('customer', {
                page: toPage,
                plateNumber: plateNumber,
                email: email,
                dateStart: (dateStart ? DateUtils.convertLocalDateToServer(dateStart) : null)
            });
        } 

        function search() {
            $state.go('customer', {
                page: 1,
                plateNumber: (vm.plateNumberInput ? vm.plateNumberInput.toUpperCase() : null),
                email: (vm.emailInput ? vm.emailInput.toLowerCase() : null)
            });
        }

        function clearSearch() {
            $state.go('customer', {
                page: 1,
                plateNumber: null,
                email: null
            });
        }

        function showCustomer(customer) {
            $state.go('customerDetails', {
                id: customer.id
            });
        }

        page = parseInt($stateParams.page, 10);
        if (!page) {
            page = 1;
        }

        plateNumber = $stateParams.plateNumber;
        email = $stateParams.email;

        vm.plateNumberInput = plateNumber;
        vm.emailInput = email;

        Customer.getById.query({
            page: page,
            plateNumber: plateNumber,
            email: email
        }, function (result) {
            vm.customers = result.customers;
            plateNumber = result.plateNumber;
            email = result.email;

            vm.pagination = {
                page: page,
                total: result.total,
                itemsPerPage: result.itemsPerPage
            };

            vm.numberOfPages = result.itemsPerPage != 0 ? Math.ceil(result.total / result.itemsPerPage) : 0;
        });
    }
})(window.angular);
